import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { query, collection, getDocs, where } from "firebase/firestore";
import { auth, db } from "../../firebase";
import { FirebaseService } from "../../services/firebase.service";
import "./Home.scss";
import Button from "../../components/Button";
import Header from "../../components/Header";
import Footer from "../../components/Footer";

const rightSideImage = require("../../assets/right-side-home-image.png");

export const Home = () => {
  const [user, loading] = useAuthState(auth);
  const navigate = useNavigate();
  const dataShareRewards = [
    "Rewards",
    "Exclusive offers",
    "Engaging experiences",
    "New product releases",
    "First-look promos",
    "Early access to tickets, passes, and more",
  ];
  useEffect(() => {
    if (loading) return;

    if (user) navigate("/dashboard");
  }, [user, loading]);

  return (
    <div className="row home-page">
      <div className="col s12 xl6 left-side-col">
        <div className="row page-wrapper">
          <div className="col s4">
            <Header logoColor="white" />
          </div>
          <div className="col s4">
            <Button size="large" onClick={() => navigate("/login")}>
              LOG IN
            </Button>
            <Button
              type="secondary"
              size="large"
              onClick={() => navigate("/register")}
            >
              SIGN UP
            </Button>
          </div>
          <Footer className="col s4" bannerColor="white" />
        </div>
      </div>
      <div className="col l6 right-side-col page-wrapper desktop-background-image">
        <div className="row">
          <div className="col l6">
            <h1 className="text-title">
              Earn points for everything you already do online.
            </h1>
            <h2 className="text-main">
              Get rewarded for browsing and shopping, logging into your favorite
              sites, signing up for newsletters, watching videos, playing games,
              and more.
            </h2>
            <h2 className="text-main second-section">
              With xID, <b>you own your data and confidently share it</b> with
              the companies or individuals you chose in exchange for:
            </h2>
            <ul>
              {dataShareRewards.map((item) => (
                <li className="text-main" key="{item}">
                  {item}
                </li>
              ))}
            </ul>
            <div className="right-side-footer">
              <img src={rightSideImage}></img>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
